import { clone, each, isEqual, map } from 'lodash';
import * as React from 'react';

import 'react-tabs/style/react-tabs.css';
import { userHasRole, userHasSubRole } from '../../util';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import * as appActions from '../../stores/app/actions';

//import "react-toggle/style.css"
import { Box, Button, Divider, LinearProgress, List, ListItem, Stack, Tab, Tabs, Typography } from '@mui/material';
import * as ReactDOM from 'react-dom';
import LegacyTable from '../../components/app/legacy-table';
import CohortStatsTable from './CohortStatsTable';
import { COHORT_SORT_PARAMS } from './constants';

import { Theme } from '@mui/material/styles';
import axios from 'axios';
import { NavigateFunction } from 'react-router-dom';
import OverviewStats from '../../components/analytics/OverviewStats';
import { withRouter } from '../../components/hoc/WithRouter';
import { APP_ELEMENT_DIMENSIONS } from '../../constants';
import { BASEStateInterface, ITeam, checkRole } from '../../stores/jotai/base';
import { TeamCollections } from '../../stores/jotai/teams/teams';
import HomeOverview from '../Home/HomeOverview';

const TOGGLE_LABEL_DASH = "Team Stats";
const TOGGLE_LABEL_STAT = "Cohort Stats";
const TOGGLE_LABEL_ACTI = "Activity Feed";
const TOGGLE_LABEL_WIKI = "Video Views";

// The stle we should apply to each header cell in our stat tables
const TABLE_HEADER_STYLE = {
    backgroundColor: 'rgb(66, 66, 66)',
    color: 'rgb(255, 255, 255)'
};

// Visual style for the overview panel next to the stats over time graph
const STATS_OVERVIEW_STYLE = {
    background: "white",
    paddingLeft: "10px",
    border: "1px solid #efefef"
};

const STATS_OVERVIEW_TABLE_STYLE = {
    width: '100%',
    paddingRight: '10px',
    paddingBottom: '10px',
    borderSpacing: '0px'
};

const STATS_OVERVIEW_TD_STYLE = {
    padding: "5px"
};

const STATS_OVERVIEW_HEADER_STYLE = {
    textAlign: 'center',
    marginBottom: '5px',
    marginTop: '10px'
}

const PROFESSOR_TOGGLE_STYLE = {
    position: 'relative',
    display: 'inline-block',
    marginLeft: '10px'
};

interface Props {
    targetView?: string;
    onViewChange?: (target) => void;
    switchTeam?: (teamID: string) => void;
    teams?: TeamCollections;
    setBase?: Function;
    baseAtomBridge?: BASEStateInterface;
    navigate?: NavigateFunction;
    theme: Theme;
    isHomeCardVisible?:boolean;
}

interface State {
    appState?: AppState;
    stats?: StatsState;
    org?: OrgState;
    team?: TeamState;
    teams?: TeamsState;
    cohort?: CohortState;
    cohorts?: CohortsState;
    loading?: boolean;
    user?: User;

    // Highcharts configurations
    interviews_and_insights_by_team: {};
    stats_over_time_by_team: {};
    engagements_by_instructor: {};
    stats_over_time_by_instructor: {};
    cohort_stats: {};
    wiki_seen_stats: {};
    professor_stats: {};
    originalData: {};
    total_cohort_stats: {};
    choosenSubData: {};
    professor_stats_table: {};
    professor_stats_overview: {};
    selectedGroupName: string;
    selectedProfName: string;

    stats_over_time_set1: {};
    stats_over_time_set2: {};

    instructorStateTableMode: boolean;
}

class TeamDashboardView extends React.Component<Props, State> {

    state = {}

    listenToStores = ['appState', 'stats', 'org', 'team', 'teams', 'cohort', 'cohorts', 'user'];

    shouldComponentUpdate(nextProps, nextState: State) {
        if (!isEqual(this.props, nextProps)) return true;
        if (!isEqual(this.state, nextState)) return true;

        return false;
    }

    clearChartsInState = () => {
        this.setState({
            interviews_and_insights_by_team: {},
            stats_over_time_by_team: {},
            cohort_stats: [],
            wiki_seen_stats: {},
            engagements_by_instructor: {},
            professor_stats: {},
            total_cohort_stats: {},
            stats_over_time_by_instructor: {},
            choosenSubData: {},
            professor_stats_table: {},
            originalData: undefined,
            selectedGroupName: undefined,
            selectedProfName: undefined,
            instructorStateTableMode: false,
            professor_stats_overview: {},
            stats_over_time_set1: {},
            stats_over_time_set2: {}
        });
    }

    // Convert any time series in the chart to date time objects
    handleConvertSeries(data) {
        if (data === undefined) return undefined;

        // No getting around this, we need to convert the date object explicity for highcharts
        for (let seriesIndex in data?.series) {

            let series = data?.series[seriesIndex];

            for (let dataIndex in series?.data) {
                let date = series?.data?.[dataIndex][0];

                // Let's use the entire reference line here, so it gets assigned correctly
                data.series[seriesIndex].data[dataIndex][0] = new Date(date).getTime();
            }
        }

        return data;
    }

    handleConvertCategory(data) {
        if (data === undefined) return undefined;

        for (let categoryIndex in data?.xAxis?.categories) {

            let category = data?.xAxis?.categories?.[categoryIndex];

            data.xAxis.categories[categoryIndex] = new Date(category);
        }

        return data;
    }

    injectResizeInConfig = (data) => {
        let newChartConfig = clone(data);

        // Inject a chart reflow func into the chart itself
        try {
            newChartConfig.func = function (chart) {
                setTimeout(() => {
                    chart.reflow();
                }, 0);
            }
        }
        catch (e) {

        }

        return newChartConfig;
    }

    handleRecievingCharts = (response) => {
        // We need to convert some date string to actual date objects
        let {
            stats_over_time_by_team,
            interviews_and_insights_by_team,
            cohort_stats,
            professor_stats,
            total_cohort_stats,
            engagements_by_instructor,
            professor_stats_table,
            stats_over_time_by_instructor,
            professor_stats_overview,
            stats_over_time_set1,
            stats_over_time_set2,
            wiki_seen_stats
        } = response;

        stats_over_time_by_team = this.handleConvertSeries(stats_over_time_by_team);

        stats_over_time_set2 = this.handleConvertSeries(stats_over_time_set2);

        // Map any data we want to display in a table
        let interp_professor_stats = map(professor_stats, (data, name) => {
            return {
                professorName: name,
                week_chart: data.week_chart
            }
        });

        let interp_cohort_stats = map(cohort_stats, (data, name) => {
            return {
                teamName: name,
                interviews: data.total_interviews,
                insights: data.total_insights,
                hypotheses: data.total_hypo,
                validatedHypotheses: data.total_hypo_val,
                invalidatedHypotheses: data.total_hypo_inval,
                week_chart: data.week_chart
            }
        });

        let interp_prof_table = map(professor_stats_table, (data, name) => {
            return data
        });

        // Compile our chart data
        this.setState({
            originalData: response,

            professor_stats: this.injectResizeInConfig(interp_professor_stats),
            professor_stats_table: interp_prof_table,
            cohort_stats: this.injectResizeInConfig(interp_cohort_stats),

            // Pull out the data
            stats_over_time_by_team,
            interviews_and_insights_by_team,
            stats_over_time_by_instructor: this.injectResizeInConfig(stats_over_time_by_instructor),
            engagements_by_instructor: this.injectResizeInConfig(engagements_by_instructor),
            total_cohort_stats,
            professor_stats_overview,
            stats_over_time_set1: this.injectResizeInConfig(stats_over_time_set1),
            stats_over_time_set2: this.injectResizeInConfig(stats_over_time_set2),
            wiki_seen_stats
        });
    }

    // Handle our chart clearing and reloading logic

    // The main idea:
    // If IN a Cohort
    // Then only re-load on cohort change
    // But change selected team otherwise
    // If NOT in a Cohort
    // Re-load and re-select on any change

    UNSAFE_componentWillUpdate(nextProps, nextState: State) {
        const nextTeam = nextProps.team,
            nextCohort = nextProps.cohort,
            {
                team, cohort
            } = this.props;

        if (nextProps.user) {
            appActions.beaconReportCurrentFeature("/dashboard");
        }

        // If it's a cohort
        if (nextProps?.cohort) {
            // And the cohort changes
            // then reload the data
            if (nextCohort && (!cohort || nextCohort.id !== cohort.id)) {

                this.clearChartsInState();

                this.handleLoadingChartData(nextProps.cohort.id);
            }

            // Always be on the lookout for any team changes, to soft change
            if (nextTeam && (!team || nextTeam.id !== team.id)) {
                this.handleChangeGroupData(nextTeam.name);
            }
        }
        else {
            // If it's not a cohort then reload on any team changes
            if (nextTeam && (!team || nextTeam.id !== team.id)) {

                this.clearChartsInState();

                this.handleLoadingChartData(nextProps.team.id);
            }
        }

    }

    // When the user clicks on a team name in the cohort stats
    // table, we want to navigate to that team
    // and switch to the /discovery feature
    handleCohortStatsTeamNavigation = (teamName: string) => {
        const { teams, switchTeam, setBase } = this.props;

        // Find the team in this cohort with the matching name,
        let team: ITeam = Object.values(teams).find(
            (team) => team?.name === teamName
        );

        if (team) {
            switchTeam(team.groupID);
            this.props.navigate('/discovery');
        }
    };


    // When given a groupID attempt to load it's data
    // This differs if its a cohort or just a regular team
    handleLoadingChartData = (groupID) => {
        // Off the top assume we don't know where the data is
        let data_artifact = '';

        if (this?.props?.cohort) {
            data_artifact = this.props.cohort?.chartDataUrl;
        }
        else {
            try {
                data_artifact = this.props.team?.chartDataUrl;
            } catch (e) {

            }
        }

        // If we never found the artifact don't attempt to load it
        if (data_artifact === '') return;

        // Pull it down
        axios.get(data_artifact).then((res) => {
            this.handleRecievingCharts(res?.data);
        });

    }

    // Centralize our logic for finding what groupID should represent the chart were currently
    // on.
    // If in a cohort use the parent, otherwise use the current team
    getCurrentGroupID = () => {
        const {
            team,
            cohort
        } = this.props;

        if (team === undefined && cohort === undefined) {
            return undefined;
        }

        if (cohort) {
            return cohort?.id;
        }
        else {
            return team?.id;
        }
    }

    isInstructorOrCA = () => {
        const { baseAtomBridge } = this.props;
        const isSystemAdmin = checkRole(
            baseAtomBridge,
            "isSystemAdministrator"
        );
        const isInstructor = checkRole(baseAtomBridge, "isInstructor");
        const isCohortAdmin = checkRole(baseAtomBridge, "isCohortAdmin");

        return isSystemAdmin || isInstructor || isCohortAdmin;
    }

    // When the component mounts always trigger a reload of the data
    componentDidMount() {
        const current_group_id = this.getCurrentGroupID();

        if (current_group_id === undefined) {
            return;
        }

        this.handleLoadingChartData(current_group_id);

        ((typeof window !== "undefined") ? document : {}).title = 'Analytics - Innovation Within';
    }


    // When a new group is detected but we don't need to reload the chart
    // just switch it's selection over
    handleChangeGroupData = (name) => {
        this.setState({
            selectedGroupName: name
        });
    }

    handleChangeProfData = (name) => {
        this.setState({
            selectedProfName: name
        });

        if (this.refs.engagements_by_single_instructor_ !== undefined) {
            const domNode = ReactDOM.findDOMNode(this.scrollNode);

            domNode.scrollTop = 1000;
        }
    }

    // Handle actually clicking on a team in the chart
    handleGroupChange = (event) => {
        // What group did we click on?
        const groupName = event.point.name;

        this.handleChangeGroupData(groupName);
    }

    handleProfChange = (event) => {
        const profName = event.point.category;

        this.handleChangeProfData(profName);
    }

    getFirstProfessorFromTable = () => {
        const {
            professor_stats_table
        } = this.state;

        if (professor_stats_table === undefined) return undefined;

        return professor_stats_table[0]?.name;
    }

    renderInstrcutorStatsOverTime() {
        const {
            stats_over_time_by_instructor,
            originalData,
            professor_stats_overview
        } = this.state;

        // Build our root chart
        const instructorOverTime = <HighchartsReact
            highcharts={Highcharts}
            options={stats_over_time_by_instructor}
        />
        // <ReactHighcharts config={stats_over_time_by_instructor} ref="stats_over_time_by_instructor_"></ReactHighcharts>

        // Build our stats overview panel
        const overviewStatsPanel = <div style={STATS_OVERVIEW_STYLE}>
            <h3 style={STATS_OVERVIEW_HEADER_STYLE}>Overview</h3>
            <table className="iw-table iw-table-overview" style={STATS_OVERVIEW_TABLE_STYLE}>
                <tr className="cs-tr-group">
                    <td style={STATS_OVERVIEW_TD_STYLE}>Canvas Comments</td>
                    <td style={STATS_OVERVIEW_TD_STYLE}>{professor_stats_overview.commentTotal}</td>
                </tr>

                <tr className="cs-tr-group">
                    <td style={STATS_OVERVIEW_TD_STYLE}>Interview Feedback (Insight)</td>
                    <td style={STATS_OVERVIEW_TD_STYLE}>{professor_stats_overview.findingTotal}</td>
                </tr>

                <tr className="cs-tr-group">
                    <td style={STATS_OVERVIEW_TD_STYLE}>Peer Feedback</td>
                    <td style={STATS_OVERVIEW_TD_STYLE}>{professor_stats_overview.chat3Total}</td>
                </tr>

                <tr className="cs-tr-group">
                    <td style={STATS_OVERVIEW_TD_STYLE}>Instructor Feedback</td>
                    <td style={STATS_OVERVIEW_TD_STYLE}>{professor_stats_overview.chat2Total}</td>
                </tr>

                <tr className="cs-tr-group">
                    <td style={STATS_OVERVIEW_TD_STYLE}>Instructor Private Chat</td>
                    <td style={STATS_OVERVIEW_TD_STYLE}>{professor_stats_overview.chat1Total}</td>
                </tr>
            </table>
        </div>

        // Render our structure
        return <div style={{ display: 'flex' }}>
            <div style={{ flexGrow: 1 }}>
                {instructorOverTime}
            </div>

            <div style={{ width: '225px' }}>
                {overviewStatsPanel}
                {this.renderLastUpdateWatermark()}
            </div>
        </div>
    }

    renderOriginalStatsOverview = () => {
        const {
            stats_over_time_by_team
        } = this.state;

        // Verify it has a plot options
        if (!stats_over_time_by_team?.plotOptions) {
            return <Box />
        }

        // We only want one category of data to be visible at a time
        // to accomplish this we need to inject a series event into the plot options
        // of what came down from the server
        stats_over_time_by_team.plotOptions.series.events = {
            show: function () {
                var chart = this.chart,
                    series = chart.series,
                    i = series.length,
                    otherSeries;
                while (i--) {
                    otherSeries = series[i];
                    if (otherSeries != this && otherSeries?.visible) {
                        otherSeries.hide();
                    }
                }
            },
            legendItemClick: function () {
                if (this.visible) {
                    return false;
                }
            }
        }

        // Now we can safely inject this data into our chart

        return <HighchartsReact
            highcharts={Highcharts}
            options={stats_over_time_by_team}
        />;
    }

    renderStatsOverviewOne = () => {
        const {
            stats_over_time_set1
        } = this.state;

        return <HighchartsReact
            highcharts={Highcharts}
            options={stats_over_time_set1}
        />;
    }

    renderStatsOverviewTwo = () => {
        const {
            stats_over_time_set2
        } = this.state;

        return <HighchartsReact
            highcharts={Highcharts}
            options={stats_over_time_set2}
        />;
    }

    renderStatsOverTime() {
        const {
            total_cohort_stats,
            stats_over_time_set1
        } = this.state;

        let statsOverTimeChart = undefined;

        if (stats_over_time_set1 === undefined) {
            statsOverTimeChart = this.renderOriginalStatsOverview();
        }
        else {
            statsOverTimeChart = (
                <Box sx={{ width: "100%" }}>
                    {this.renderStatsOverviewTwo()}
                    <Divider sx={{ my: 3 }} />
                    {this.renderStatsOverviewOne()}
                </Box>
            );
        }

        // Render our structure
        return (
            <Stack direction="row">
                <Box
                    style={{
                        flexGrow: 1,
                        width: `calc(100% - ${APP_ELEMENT_DIMENSIONS.ANALYTICS.COHORT_STATS.OVERVIEW_PANEL.WIDTH})`,
                    }}
                >
                    {statsOverTimeChart}
                </Box>
                <Box
                    style={{
                        width:
                            APP_ELEMENT_DIMENSIONS.ANALYTICS.COHORT_STATS.OVERVIEW_PANEL
                                .WIDTH,
                    }}
                >
                    <OverviewStats
                        interviews={total_cohort_stats?.total_interviews}
                        insights={total_cohort_stats?.total_insights}
                        hypotheses={total_cohort_stats?.total_hypo}
                        validHypotheses={total_cohort_stats?.total_hypo_val}
                        invalidHypotheses={total_cohort_stats?.total_hypo_inval}
                    />
                    {this.renderLastUpdateWatermark()}
                </Box>
            </Stack>
        );
    }

    renderDashboard() {
        const {
            interviews_and_insights_by_team,
            originalData,
            selectedGroupName
        } = this.state;

        const {
            team,
            cohort,
            teams,
        } = this.props;

        // Handle any modifications to the actual data we need to do
        if (interviews_and_insights_by_team) {
            interviews_and_insights_by_team.plotOptions.series.events = {
                click: this.handleGroupChange
            }
        }

        let useableGroup = selectedGroupName;

        if (useableGroup === '' || useableGroup === undefined) {
            if (team) {
                useableGroup = team.name;
            }
            else {
                // If were in a root cohort just select the first team
                useableGroup = teams?.[cohort.teams[0]]?.name;
            }
        }

        // Determine our team name to use for sub-chart selection
        const byWeekName = "interviews_and_insights_by_week_" + useableGroup;
        const byMemberName = "interviews_and_insights_by_member_" + useableGroup;

        // Make sure the selected group actually exists
        if (originalData[byWeekName] === undefined) {
            return <span></span>
        }

        // Now build all of our charts

        const totalInsightsPlot = <HighchartsReact
            highcharts={Highcharts}
            options={interviews_and_insights_by_team}
        />;
        const interviewsByWeek = <HighchartsReact
            highcharts={Highcharts}
            options={originalData?.[byWeekName]}
        />;
        const interviewsByMember = <HighchartsReact
            highcharts={Highcharts}
            options={originalData?.[byMemberName]}
        />;


        let statsOverTimeSection = <List>
            {this.renderStatsOverTime()}
        </List>;

        if (cohort) {
            statsOverTimeSection = null;
        }

        return <span>
            {statsOverTimeSection}

            <List>
                {totalInsightsPlot}
            </List>

            <List>
                {interviewsByWeek}
            </List>

            <List>
                {interviewsByMember}
            </List>
        </span>
    }

    renderInstructorHeader() {
        const {
            instructorStateTableMode
        } = this.state;

        return <ListItem>
            <span style={PROFESSOR_TOGGLE_STYLE}>
                <Button style={{
                    opacity: instructorStateTableMode ? 0.5 : 1.0
                }} onClick={() => {
                    this.setState({
                        instructorStateTableMode: false
                    });
                }}>Stats Graph</Button>
                <Button style={{
                    opacity: instructorStateTableMode ? 1.0 : 0.5,
                    marginLeft: '10px'
                }} onClick={() => {
                    this.setState({
                        instructorStateTableMode: true
                    });
                }}>Stats Table</Button>
            </span>
        </ListItem>
    }

    renderInstructorStats() {
        const {
            engagements_by_instructor,
            originalData,
            selectedProfName,
            instructorStateTableMode
        } = this.state;

        if (engagements_by_instructor === undefined) {
            return <span>
                <List>
                    <h4 style={{ textAlign: 'center' }}>
                        The Instructor Engagements Statistics are still processing.
                    </h4>
                </List>
            </span>
        }

        if (engagements_by_instructor) {
            engagements_by_instructor.plotOptions.series.events = {
                click: this.handleProfChange
            }
        }

        const statsByInstructor = <HighchartsReact
            highcharts={Highcharts}
            options={engagements_by_instructor}
        />; 
        
        let byInstructorName = 'engagements_by_single_instructor_' + this.getFirstProfessorFromTable();

        if (selectedProfName !== undefined) {
            byInstructorName = "engagements_by_single_instructor_" + selectedProfName;
        }

        const statsByInstructorSingle = <HighchartsReact
            highcharts={Highcharts}
            options={originalData[byInstructorName]}
        />; 

        if (instructorStateTableMode) {
            return <span>
                {this.renderInstrcutorStatsOverTime()}
                {this.renderProfessorTable()}
            </span>
        }
        else {
            return <span>
                {this.renderInstrcutorStatsOverTime()}
                {statsByInstructor}
                {statsByInstructorSingle}
            </span>
        }
    }

    renderCohortStatsTeamNameCell = (teamName) => {
        const { theme } = this.props;
        return (
            <Box
                onClick={() => {
                    if (this.isInstructorOrCA()) {
                        this.handleCohortStatsTeamNavigation(teamName);
                    }
                }}
                sx={{
                    ...(this.isInstructorOrCA() && {
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: theme.custom.mainButtonHighlight,
                    }),
                }}
            >
                {teamName}
            </Box>
        );
    };

    renderProfessorTable() {
        const {
            professor_stats_table
        } = this.state;

        // Define our columns
        // primarily this is the header text, the accessor that corrisponds from it's data
        // and anything specific needed for the charts
        let columns = [
            { Header: 'Instructor', sortMethod: (a, b) => { return a > b; }, headerStyle: TABLE_HEADER_STYLE, accessor: 'name' },
        ]

        for (let i = 1; i < professor_stats_table[0]?.total_weeks + 1; i++) {
            columns.push({
                Header: ("Week " + i.toString()),
                headerStyle: TABLE_HEADER_STYLE,
                accessor: 'week_' + i.toString()
            });
        }

        columns.push({
            Header: 'Total',
            headerStyle: TABLE_HEADER_STYLE,
            accessor: 'total'
        });

        const table = <LegacyTable
            showPagination={false}
            pageSize={professor_stats_table.length}
            data={professor_stats_table}
            columns={columns}
            defaultSorted={
                [
                    {
                        id: "name",
                        desc: false
                    }
                ]
            }
            className={"iw-table iw-selectable"}
        />

        return table;
    }

    renderCohortStatsTable() {
        const {
            cohort_stats
        } = this.state;

        // Define our columns
        // primarily this is the header text, the accessor that corrisponds from it's data
        // and anything specific needed for the charts
        const columns = [
            {
                name: "Team Name",
                fieldKey: COHORT_SORT_PARAMS.FIELD_IDS.TEAM_NAME,
                sortable: true,
                Cell: this.renderCohortStatsTeamNameCell,
            },
            {
                name: "Interview Quotas",
                fieldKey: COHORT_SORT_PARAMS.FIELD_IDS.INTERVIEW_QUOTAS,
                sortable: false,
                Cell: (chartValues) => (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={chartValues}
                    />
                ), //<ReactHighcharts config={props.value}></ReactHighcharts>
            },
            {
                name: "Interviews",
                fieldKey: COHORT_SORT_PARAMS.FIELD_IDS.INTERVIEWS,
                sortable: true,
            },
            {
                name: "Insights",
                fieldKey: COHORT_SORT_PARAMS.FIELD_IDS.INSIGHTS,
                sortable: true,
            },
            {
                name: "Hypotheses",
                fieldKey: COHORT_SORT_PARAMS.FIELD_IDS.HYPOTHESES,
                sortable: true,
            },
            {
                name: "Validated Hypotheses",
                fieldKey: COHORT_SORT_PARAMS.FIELD_IDS.VALIDATED_HYPOTHESES,
                sortable: true,
            },
            {
                name: "Invalidated Hypotheses",
                fieldKey: COHORT_SORT_PARAMS.FIELD_IDS.INVALIDATED_HYPOTHESE,
                sortable: true,
            },
        ];

        return <CohortStatsTable columns={columns} cohortStats={cohort_stats} />
    }

    constructTeamTable(groupID: string) {
        const {
            wiki_seen_stats
        } = this.state;

        let calculatedTableData = [];
        const groupData = wiki_seen_stats["teamStats"][groupID];

        let longestNameLength = 0;

        if (groupData === undefined) return <span></span>

        // Otherwise build a list of all the user's in this group
        each(groupData?.users, groupDataUser => {
            // Check if this username is now the longest
            if (groupDataUser?.userName?.length > longestNameLength) {
                longestNameLength = groupDataUser?.userName?.length;
            }

            let userConstruction = {
                user: groupDataUser.userName,
                allSet: false
            }

            let anyUnder100 = false;

            // Get a total for each "section"
            each(wiki_seen_stats?.sectionDefinition, wikiSection => {
                const sectionGoalScore = parseFloat(wikiSection?.linksTotal?.toString());
                let sectionResultingScore = 0.0;

                each(wikiSection?.links, linkInSection => {
                    sectionResultingScore += parseFloat(groupDataUser?.counts[linkInSection?.id.toString()]?.toString());
                });

                userConstruction[wikiSection.id] = {
                    totalSection: sectionGoalScore,
                    completed: sectionResultingScore,
                    percentage: sectionResultingScore / sectionGoalScore,
                };

                if (userConstruction?.[wikiSection?.id] === undefined) {
                    userConstruction[wikiSection.id] = {
                        totalSection: sectionGoalScore,
                        completed: 0,
                        percentage: 0.0,
                    };
                }

                // Check to see if any sections aren't 100% complete, 
                // if not then we don't want to mark them as "up to date"
                if (userConstruction?.[wikiSection?.id]?.percentage < 100.0) {
                    anyUnder100 = true;
                }
            });

            if (anyUnder100 === false) {
                userConstruction.allSet = true;
            }

            calculatedTableData.push(userConstruction);
        });

        // How many PX should we use for each character?
        const characterSpacingPer = 10;
        const userColumnWidth = longestNameLength * characterSpacingPer;

        let columns: any[] = [{
            Header: "Student",
            accessor: "user",
            width: userColumnWidth,
            style: { whiteSpace: 'nowrap' },
            Cell: props => <span>{props.value}</span>
        }]

        let sectionDefinitionsAsArray = [];

        each(wiki_seen_stats?.sectionDefinition, wikiSection => {
            sectionDefinitionsAsArray.push(wikiSection);
        });

        sectionDefinitionsAsArray = sectionDefinitionsAsArray.sort((a, b) => {
            return a?.name?.localeCompare(b?.name);
        });

        sectionDefinitionsAsArray.forEach((wikiSection, idx) => {
            columns.push({
                Header: wikiSection.name,
                name: wikiSection.name,
                accessor: wikiSection.id,
                width: "auto",
                style: { whiteSpace: "unset" },
                Cell: (props: any) => {
                    if (props.value.percentage === undefined) {
                        return <span>Missing</span>;
                    }

                    const completedPercent =
                        parseFloat(props.value.percentage.toString()) * 100.0;

                    return (
                        <Box
                            key={wikiSection.id}
                            sx={{
                                height: "20px",
                                display: "block",
                                position: "relative",
                            }}
                        >
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    fontSize: "12px",
                                    textShadow: "0px 0px 4px white",
                                    zIndex: 1,
                                }}
                            >
                                {props.value.completed}/
                                {props.value.totalSection}
                            </Box>
                            <LinearProgress
                                variant="determinate"
                                value={completedPercent}
                                sx={{
                                    height: "inherit",
                                    borderRadius: "4px",
                                }}
                            />
                        </Box>
                    );
                },
            });
        });

        return (
            <Box
                sx={{
                    ".MuiTableCell-root": {
                        fontSize: "13px !important",
                        minWidth: "130px",
                        textAlign: "left",
                        verticalAlign: "bottom",
                    },
                }}
            >
                    {
                        calculatedTableData?.length > 0 && <LegacyTable
                        showPagination={false}
                        pageSize={calculatedTableData.length}
                        data={calculatedTableData}
                        columns={columns}
                        defaultSorted={[
                            {
                                id: "user",
                                desc: false,
                            },
                        ]}
                    />
                    }
            </Box>
        );
    }

    renderWikiStats() {
        const {
            wiki_seen_stats
        } = this.state;
        const { theme } = this.props;
        let allTeams = [];

        // Utilize every team in the teamStats data package
        each(wiki_seen_stats["teamStats"], team => {
            allTeams.push(
                <Box
                    key={team.id}
                    sx={{
                        padding: "16px",
                        borderRadius: "4px",
                        boxShadow:
                            "0 0 0 0.67px rgba(0, 0, 0, 0.09), 0 34px 20px rgba(0, 0, 0, 0.024)",
                        transition: `box-shadow 0.15s ${theme.custom.timingFunction1}`,
                        ":hover": {
                            boxShadow: `0 0 0 3px ${theme.custom.homeCardBoldGray}`,
                        },
                    }}
                >
                    <Box
                        component="h3"
                        sx={{
                            marginTop: 0,
                            paddingBottom: "8px",
                            borderBottom: "1px solid rgba(0, 0, 0, 0.09)",
                        }}
                    >
                        {team.name}
                    </Box>
                    {this.constructTeamTable(team.id)}
                </Box>
            );
        });

        return (
            <Stack
                style={{
                    padding: "48px",
                    gap: "32px",
                }}
            >
                {allTeams}
            </Stack>
        );
    }

    renderCohortStats() {
        return (
            <>
                <Box
                    sx={{
                        padding: "16px",
                    }}
                >
                    {this.renderStatsOverTime()}
                </Box>
                <Box
                    sx={{
                        padding: "16px",
                    }}
                >
                    {this.renderCohortStatsTable()}
                </Box>
            </>
        );
    }

    renderActivityFeed() {
        return <p>Activity view was here IF you found any use let us know</p>
    }

    __isInstructorStatsEnabled = () => {
        const {
            cohort
        } = this.props;

        if (cohort && cohort.isInstructorEngagementsVisible === 1) {
            if (this.isInstructorOrCA()) {
                return true;
            }
        }

        return false;
    }

    __buildFeatureLibrary = () => {
        const {
            cohort
        } = this.props;

        // Full tab order ->
        // Cohort Stats, Instructor Stats, Team Stats, Activity Feed

        let featureLibrary = [];

        let shouldHaveCohortStats = false;
        let shouldHaveInstructorStats = this.__isInstructorStatsEnabled();

        if (cohort) {
            shouldHaveCohortStats = true;
        }

        let indexSoFar = 0;
        if (shouldHaveCohortStats) {
            featureLibrary.push({
                name: TOGGLE_LABEL_STAT,
                index: indexSoFar,
                feature: 'cohort_stats'
            });

            indexSoFar += 1;
        }

        featureLibrary.push({
            name: TOGGLE_LABEL_DASH,
            index: indexSoFar,
            feature: 'dash'
        });

        indexSoFar += 1;

        if (shouldHaveInstructorStats) {
            featureLibrary.push({
                name: 'Instructor Stats',
                index: indexSoFar,
                feature: 'prof_stats'
            });

            indexSoFar += 1;
        }

        if (cohort) {
            featureLibrary.push({
                name: TOGGLE_LABEL_WIKI,
                index: indexSoFar,
                feature: 'wiki_seen'
            });
        }

        indexSoFar += 1;

        featureLibrary.push({
            name: TOGGLE_LABEL_ACTI,
            index: indexSoFar,
            feature: 'activity_view'
        });

        return featureLibrary;
    }

    handleTabChange = (tabIndex) => {
        const featureLibrary = this.__buildFeatureLibrary();

        const matchingFeature = featureLibrary?.find((feature) => {
            return feature.index === tabIndex
        });

        if (matchingFeature === undefined) return;

        this.props.onViewChange(matchingFeature.feature);
    }

    determineCurrentTabIndex = (featureName) => {
        const featureLibrary = this.__buildFeatureLibrary();

        const matchingFeature = featureLibrary?.find((feature) => {
            return feature.feature === featureName
        });

        if (matchingFeature === undefined) return 0;

        return matchingFeature.index;
    }

    renderPageToolbar() {
        const {
            team,
            cohort,
            theme
        } = this.props;

        if (team === undefined) {
            return <span></span>
        }

        const {
            targetView
        } = this.props;

        // Construct the title to use in our toolbar
        // If were not in a cohort simply use our team name
        // Otherwise show the starting date, then either the end date
        // or the current week that we are one
        // E.x.
        // Dashboard: 5/8/2017 - Week 4
        // Dashboard: 5/8/2017 - 8/8/2017
        // Dashboard: 01_LKASD

        let toolbarTitle = "Analytics: ";

        if (cohort) {
            // Use date info
            let shortStartDate = new Date(cohort.startDate).toLocaleDateString();
            let shortEndDate = new Date(cohort.endDate).toLocaleDateString();

            // Check if it's over yet
            if (cohort.currentWeek < cohort.totalWeeks) {
                toolbarTitle += shortStartDate + " - Week " + cohort.currentWeek;
            }
            else {
                toolbarTitle += shortStartDate + " - " + shortEndDate;
            }
        }
        else {
            // Simply append the team name
            toolbarTitle += team.name;
        }

        // Determine if we should show instructor content
        const isInstructorEngagmentEnabled = this.__isInstructorStatsEnabled();

        const selectedTab = this.determineCurrentTabIndex(targetView);

        const teamNavigationPanel = <Tabs value={selectedTab}>
            <Tab label={TOGGLE_LABEL_DASH} onClick={() => this.handleTabChange(this.determineCurrentTabIndex("dash"))} />
        </Tabs>

        const cohortNavigationPanel = <Tabs value={selectedTab} >
            <Tab label={TOGGLE_LABEL_STAT} onClick={() => this.handleTabChange(this.determineCurrentTabIndex("cohort_stats"))} />
            <Tab label={TOGGLE_LABEL_DASH} onClick={() => this.handleTabChange(this.determineCurrentTabIndex("dash"))} />
            {isInstructorEngagmentEnabled ? <Tab label="Instructor Stats" value={this.determineCurrentTabIndex("prof_stats")} onClick={() => this.handleTabChange(this.determineCurrentTabIndex("prof_stats"))} /> : undefined}
            <Tab label={TOGGLE_LABEL_WIKI} onClick={() => this.handleTabChange(this.determineCurrentTabIndex("wiki_seen"))} />
        </Tabs>

        let navigationPanel = teamNavigationPanel;

        if (cohort) {
            navigationPanel = cohortNavigationPanel;
        }

        // Return our content wrapped in the toolbar structure
        return <Stack direction="row" spacing={0} sx={{
            background: theme.custom.mainBackgroundColor,
        }}>
            <Stack>
                <ListItem>
                    <Typography >{toolbarTitle}</Typography>
                </ListItem>
                {(targetView === "prof_stats") ? this.renderInstructorHeader() : undefined}
            </Stack>
            <Box sx={{ marginLeft: "auto" }}>
                {navigationPanel}
            </Box>
        </Stack>
    }

    renderLoadingSpan() {
        return <div className={'padding-30'}><LinearProgress /></div>;
    }

    renderNotInCohort() {
        return <div>
            <div className={'padding-30'} style={{ textAlign: 'center' }}><span>You must be a part of this team to view the dashboard</span></div>
        </div>

    }

    renderLastUpdateWatermark() {
        let dateToShow = undefined;

        try {
            dateToShow = this.state.originalData['lastEditTime'];
        }
        catch (e) {

        }

        if (dateToShow === undefined) {
            return <span />
        }

        return <Box sx={{opacity: '0.6', fontSize: '0.8rem !important', textAlign: 'center', paddingTop: '10px'}}>
            <Typography>Updated on {dateToShow}</Typography>
        </Box>
    }

    render() {
        const {
            targetView,
            cohort,
            user,
            team,
            theme
        } = this.props;

        const {
            originalData
        } = this.state;

        // The toolbar and structure of the page doesn't change depdning on the view
        // inject into the guts as you wish with the targetView logic
        let page_guts = this.renderLoadingSpan();

        // Verify the user is supposed to see this data
        const isUserInTeams = userHasSubRole('*', user, cohort);
        const isUserInCohort = userHasRole('*', user, cohort);
        const isUserInTeam = userHasRole('*', user, team);

        // If they aren't in the cohort or team give them an error message
        if (!(isUserInCohort || isUserInTeams || isUserInTeam)) {
            //return this.renderNotInCohort();
        }

        // Ignore the various target views if our data hasn't loaded yet
        if (originalData !== undefined) {
            // If there isn't a cohort just render the dashboard
            if (!cohort) {
                page_guts = this.renderDashboard();

                // Unless they specify the activity feed
                if (targetView === 'activity_view') {
                    page_guts = this.renderActivityFeed();
                }
            }
            else {
                // Depending on the selected view return different components
                if (targetView === 'cohort_stats') {
                    page_guts = this.renderCohortStats();
                }

                if (targetView === 'dash') {
                    page_guts = this.renderDashboard();
                }

                if (targetView === 'prof_stats') {
                    page_guts = this.renderInstructorStats();
                }

                if (targetView === 'activity_view') {
                    page_guts = this.renderActivityFeed();
                }

                if (targetView === 'wiki_seen') {
                    page_guts = this.renderWikiStats();
                }
            }
        }

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    height: "100%",
                }}
            >
                {
                    this?.props?.isHomeCardVisible ? <Box my={2}><HomeOverview /></Box> : null
                }
                {this.renderPageToolbar()}
                <Box
                    sx={{
                        height: "100%",
                        overflowY: "scroll",
                        backgroundColor: theme.custom.white,
                        "*": {
                            fontFamily: `${theme.custom.fontFamily} !important`,
                        }
                    }}
                >
                    {page_guts}
                </Box>
            </div>
        );
    }
}
export default withRouter(TeamDashboardView)